import { IMeetingChangeset } from '../abstract-meeting-changeset';
import { IControlMeetingDetailsDTO } from '../../../api/control.dao';
import { IOperatorDetailsDTO } from '../../../api/rooms.dao';
import { MeetingRoomOperatorsEventBody, SyncOperatorDetails } from '../index';

export class OperatorsUpdatedInTheMeetingRoom extends IMeetingChangeset<MeetingRoomOperatorsEventBody> {
    public applyChangesToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): Partial<IControlMeetingDetailsDTO> {
        this.updateOperatorsInMeetingRoom(meeting);
        return meeting;
    }

    public getMeetingRoomId(): number {
        return super.getChangeset().roomId;
    }

    private updateOperatorsInMeetingRoom(meeting: Partial<IControlMeetingDetailsDTO>): void {
        const { room: { operators }} = meeting;

        this.syncedOperators.forEach(syncedOperator => {
            const idx = this.getOperatorIndexById(syncedOperator.operatorId, operators);
            if (idx !== -1) {
                const operator = operators[idx];
                this.updateOperatorRole(syncedOperator, operator);
                this.updateOperatorStatus(syncedOperator, operator);
            }
        });
    }

    private get syncedOperators(): SyncOperatorDetails[] {
        return super.getChangeset().operators;
    }

    private getOperatorIndexById(id: number, operators: IOperatorDetailsDTO[]): number {
        return operators.findIndex(operator => operator.operatorId === id);
    }

    private updateOperatorRole(syncedOperator: SyncOperatorDetails, operator: IOperatorDetailsDTO): void {
        operator.operatorRole = syncedOperator.role || null;
    }
    private updateOperatorStatus(syncedOperator: SyncOperatorDetails, operator: IOperatorDetailsDTO): void {
        if (syncedOperator.status) {
            operator.operatorStatus = syncedOperator.status;
        }
    }
}
